import { DisplayedDateChangeRequestStatusData } from '@/interfaces/dateChangeRequest';
import { action, Module, mutation, VuexModule } from 'vuex-class-component';

@Module()
export class DateChangeRequestsModule extends VuexModule {
  private displayedDateChangeRequestStatus: DisplayedDateChangeRequestStatusData | undefined;

  @action({ mode: 'mutate' })
  public async setDisplayedDateChangeRequestStatusData(data: DisplayedDateChangeRequestStatusData) {
    this.setDisplayedDateChangeRequestStatus(data);
  }

  get displayedStatus(): DisplayedDateChangeRequestStatusData | undefined {
    return this.displayedDateChangeRequestStatus;
  }

  @mutation private setDisplayedDateChangeRequestStatus(data: DisplayedDateChangeRequestStatusData) {
    this.displayedDateChangeRequestStatus = data;
  }
}
